import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-mat-spinner-overlay',
    templateUrl: './mat-spinner-overlay.component.html',
    styleUrls: ['./mat-spinner-overlay.component.scss']
})
export class MatSpinnerOverlayComponent implements OnInit {

    constructor() { }

    @Input() value: number = 100;
    @Input() diameter: number = 70;
    @Input() mode: string = "indeterminate";
    @Input() overlay: boolean = false;


    ngOnInit() {

    }

}